export const parseDateLike = (value) => {
  if (value == null) return null;

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "number") {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  if (typeof value !== "string") return null;

  const raw = value.trim();
  if (!raw) return null;

  // "1700000000" (seconds) or "1700000000000" (ms)
  if (/^\d+$/.test(raw)) {
    const n = Number(raw);
    const ms = n < 1e12 ? n * 1000 : n;
    const d = new Date(ms);
    return isNaN(d.getTime()) ? null : d;
  }

  // Normalize common SQL datetime "YYYY-MM-DD HH:mm:ss" to ISO-ish.
  let normalized = raw.replace(" ", "T");

  // If the string looks like ISO without timezone, assume UTC to avoid env-dependent parsing.
  // Examples: "2026-03-15T13:05", "2026-03-15T13:05:10", "2026-03-15T13:05:10.123"
  const looksIsoNoTz =
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?$/.test(normalized);
  const hasTz = /([zZ]|[+-]\d{2}:\d{2})$/.test(normalized);
  if (looksIsoNoTz && !hasTz) normalized += "Z";

  const d = new Date(normalized);
  return isNaN(d.getTime()) ? null : d;
};

export const formatRelativeTime = (dateString) => {
  const date = parseDateLike(dateString);
  if (!date) return "Unknown date";

  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();

  // Future timestamps or clock skew: treat as "Just now"
  if (diffInMs <= 0) return "Just now";

  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInMinutes < 1) return "Just now";
  if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
  if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
  if (diffInDays === 1) return "Yesterday";
  if (diffInDays < 7) return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatPriorityDate = (dateString) => {
  if (!dateString) return "N/A";

  const date = parseDateLike(dateString);
  if (!date) return "Invalid date";

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatTooltipContent = (content) => {
  if (!content) return "No content";

  const div = document.createElement("div");
  div.innerHTML = content;
  const text = div.textContent || div.innerText || "";

  if (text.length > 150) {
    return text.substring(0, 150) + "...";
  }

  return text;
};

export const getFullDate = (dateString) => {
  if (!dateString) return "";
  
  const date = parseDateLike(dateString);
  if (!date) return "";
  
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};